var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-renderer-badge flex items-center h-full",style:(_vm.params.cssVariables)},[_c('div',{staticClass:"badge text-inherit flex-shrink-0 flex justify-center items-center"},[_c('span',{staticClass:"badge-text"},[_vm._v("\n      "+_vm._s(_vm.params.text)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }